module.exports = __webpack_public_path__ + "img/share.b79afe00.png";